import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import {
	TableContainer,
	Table,
	Paper,
	TableHead,
	TableRow,
	TableCell,
	CircularProgress,
	TableBody,
} from '@material-ui/core';
import { getTotalStaffs } from '@/app/services/SuperAdminHomeService/superAdminHomeService';
import InfiniteScroll from 'react-infinite-scroll-component';

const TotalStaff = () => {
	const dispatch = useDispatch();
	const [isStaffloading, setStaffLoading] = useState(false);
	const [staffCount, setStaffCount] = useState(null);
	const [viewAll, setViewAll] = useState(false);
	const [staffs, setStaffs] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	const [page, setPage] = useState(1);
	const [loadingMore, setLoadingMore] = useState(false);

	useEffect(() => {
		let isMounted = true;
		setStaffLoading(true);
		getTotalStaffs(1)
			.then(({ data }) => {
				if (!isMounted) return;
				setStaffs(data.data);
				setStaffCount(data.total);
				if (data.current_page < data.last_page) {
					setHasMore(true);
					setPage(data.current_page + 1);
				} else {
					setHasMore(false);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				if (err.response?.data?.message) {
					dispatch(
						Actions.showMessage({
							message: err?.response?.data?.message,
							autoHideDuration: 2500,
							variant: 'error',
						}),
					);
				} else {
					dispatch(
						Actions.showMessage({
							message: 'Failed to load staffs',
							autoHideDuration: 2500,
							variant: 'error',
						}),
					);
				}
			})
			.finally(() => {
				if (!isMounted) return;
				setStaffLoading(false);
			});
		return () => {
			isMounted = false;
		};
	}, []);

	const handleLoadMore = () => {
		setLoadingMore(true);
		getTotalStaffs(page)
			.then(({ data }) => {
				setStaffs(staffs.concat(data.data));
				if (data.current_page < data.last_page) {
					setHasMore(true);
					setPage(data.current_page + 1);
				} else {
					setHasMore(false);
				}
			})
			.catch((err) => {
				if (err.response?.data?.message) {
					dispatch(
						Actions.showMessage({
							message: err?.response?.data?.message,
							autoHideDuration: 2500,
							variant: 'error',
						}),
					);
				} else {
					dispatch(
						Actions.showMessage({
							message: 'Failed to load staffs',
							autoHideDuration: 2500,
							variant: 'error',
						}),
					);
				}
			})
			.finally(() => {
				setLoadingMore(false);
			});
	};

	return (
		<>
			<div className="flex flex-row justify-between items-center">
				<h3>
					<span className="" style={{ fontSize: '18px', fontWeight: '700' }}>
						Staff
					</span>{' '}
					<span>|</span> <span className="school-count font-extrabold">{staffCount || ''}</span>
				</h3>
				{!viewAll && staffs.length > 5 ? (
					<span>
						<CustomButton
							fontSize="15px"
							onClick={() => {
								setViewAll(true);
							}}
							style={{ justifyContent: 'space-evenly', display: 'flex', alignItems: 'center' }}
							variant="secondary"
						>
							View all <span className="chevron-right-icon">&#8250;</span>
						</CustomButton>
					</span>
				) : (
					''
				)}
			</div>
			<TableContainer className="staff-table-cont" component={Paper} id="Scrollable-table">
				<Table stickyHeader style={{ width: '100%' }}>
					<TableHead>
						<TableRow>
							<TableCell
								className="bg-white schoolTableHeader w-1/4"
								style={{
									fontSize: '13px',
								}}
							>
								Name
							</TableCell>
							<TableCell
								className="bg-white schoolTableHeader w-1/4"
								style={{
									fontSize: '13px',
								}}
							>
								School
							</TableCell>
							<TableCell
								className="bg-white schoolTableHeader w-1/4"
								style={{
									fontSize: '13px',
								}}
							>
								Email
							</TableCell>
							<TableCell
								className="bg-white schoolTableHeader w-1/4"
								style={{
									fontSize: '13px',
								}}
							>
								Phone
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isStaffloading ? (
							<TableRow>
								<TableCell align="center" className="bg-white" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : null}
						{!staffs[0] && !isStaffloading ? (
							<TableRow>
								<TableCell align="center" className="bg-white no-staffs" colSpan={8}>
									No staffs
								</TableCell>
							</TableRow>
						) : null}
						{staffs.slice(0, viewAll ? staffs.length : 5).map((staff, key) => {
							return (
								<TableRow key={key}>
									<TableCell
										className="bg-white"
										style={{
											fontSize: '13px',
											maxWidth: '100px',
											fontWeight: 'bold',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											whiteSpace: 'nowrap',
										}}
									>
										{staff.first_name} {staff.last_name}
									</TableCell>
									<TableCell
										className="bg-white staff-table-cell"
										style={{
											fontSize: '13px',
										}}
									>
										{staff?.school?.name}
									</TableCell>
									<TableCell
										className="bg-white staff-table-cell"
										style={{
											fontSize: '13px',
										}}
									>
										{staff?.email}
									</TableCell>
									<TableCell
										className="bg-white"
										style={{
											fontSize: '13px',
											maxWidth: 100,
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											whiteSpace: 'nowrap',
										}}
									>
										<div className="flex flex-row">
											<img alt="Phone number" src="assets/images/phone.png" />
											{staff.phone}
										</div>
									</TableCell>
								</TableRow>
							);
						})}
						{loadingMore ? (
							<TableRow>
								<TableCell align="center" className="bg-white" colSpan={8}>
									<CircularProgress size={35} />
								</TableCell>
							</TableRow>
						) : null}
					</TableBody>
				</Table>
			</TableContainer>
			{viewAll ? (
				<InfiniteScroll
					dataLength={staffs.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			) : null}
		</>
	);
};

export default TotalStaff;
